// ── Clinic configuration ──────────────────────────────────────────────────────
// Change any value here to update it across the entire app.

export const CLINIC_NAME     = 'Brightside Dental';
export const CLINIC_SUBTITLE = 'Queue System';
export const CLINIC_TAGLINE  = 'Patient History Report';

// Shown in the billing print header — update these to your clinic's details
export const CLINIC_ADDRESS  = '15 Main Street, chennai, Tamil Nadu - 600028';
export const CLINIC_PHONE    = '+91 12345 67891';
export const CLINIC_EMAIL    = '';   // optional — leave blank to hide
